// extracted by mini-css-extract-plugin
export default {"layout":"layout_Ae4B_DA","widthBox":"widthBox_jHa_1sP","main":"main_YvQcm4_","sidebar":"sidebar_tysGR18"};